export default function Paper(theme) {
  return {
    MuiPaper: {
      defaultProps: {
        variant: theme.palette.mode === 'dark' ? 'outlined' : 'elevation',
      },
      styleOverrides: {
        rounded: {
          borderRadius: theme.spacing(2),
        },
      },
    },
  }
}
